const STORAGE_KEY = "lists.navigationHistory";
const MAX_ENTRIES = 40;

function canUseStorage() {
  return typeof window !== "undefined" && typeof window.sessionStorage !== "undefined";
}

function readStack(): string[] {
  if (!canUseStorage()) return [];
  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed.filter(item => typeof item === "string") : [];
  } catch {
    return [];
  }
}

function writeStack(stack: string[]) {
  if (!canUseStorage()) return;
  window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(stack.slice(-MAX_ENTRIES)));
}

export function recordNavigation(path: string) {
  const stack = readStack();
  if (stack[stack.length - 1] === path) return;
  writeStack([...stack, path]);
}

export function findSmartBackTarget(
  currentPath: string,
  isValidTarget: (path: string) => boolean,
): string | null {
  const stack = readStack();
  let index = stack.length - 1;

  while (index >= 0 && stack[index] === currentPath) index--;
  while (index >= 0) {
    const candidate = stack[index]!;
    if (isValidTarget(candidate)) {
      writeStack(stack.slice(0, index + 1));
      return candidate;
    }
    index--;
  }

  writeStack([]);
  return null;
}
